import { render, staticRenderFns } from "./ProductStickyElement.vue?vue&type=template&id=284db94e&scoped=true&"
import script from "./ProductStickyElement.vue?vue&type=script&lang=ts&"
export * from "./ProductStickyElement.vue?vue&type=script&lang=ts&"
import style0 from "./ProductStickyElement.vue?vue&type=style&index=0&id=284db94e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284db94e",
  null
  
)

export default component.exports